var _rect, _rect2, _rect3, _mask, _path, _path2, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMpctls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 58,
    viewBox: "0 0 51 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 7.5835,
    width: 49.6447,
    height: 49.6447,
    rx: 8.1,
    fill: "#FD4C00",
    stroke: "#101010",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.3687,
    y: 43.4635,
    width: 15.0798,
    height: 15.0798,
    transform: "rotate(-135 31.3687 43.4635)",
    fill: "white",
    stroke: "#101010",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.0166,
    y: 43.4635,
    width: 15.0798,
    height: 15.0798,
    transform: "rotate(-135 19.0166 43.4635)",
    fill: "white",
    stroke: "#101010",
    strokeWidth: 0.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_3177_3545",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1928 27.9606L30.0325 32.8004L25.1928 37.6401L20.353 32.8004L25.1928 27.9606Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1928 27.9606L30.0325 32.8004L25.1928 37.6401L20.353 32.8004L25.1928 27.9606Z",
    fill: "#FD4C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1928 27.9606L25.5463 27.6071L25.1928 27.2535L24.8392 27.6071L25.1928 27.9606ZM30.0325 32.8004L30.3861 33.1539L30.7396 32.8004L30.3861 32.4468L30.0325 32.8004ZM25.1928 37.6401L24.8392 37.9937L25.1928 38.3472L25.5463 37.9937L25.1928 37.6401ZM20.353 32.8004L19.9995 32.4468L19.6459 32.8004L19.9995 33.1539L20.353 32.8004ZM24.8392 28.3142L29.679 33.1539L30.3861 32.4468L25.5463 27.6071L24.8392 28.3142ZM29.679 32.4468L24.8392 37.2866L25.5463 37.9937L30.3861 33.1539L29.679 32.4468ZM25.5463 37.2866L20.7066 32.4468L19.9995 33.1539L24.8392 37.9937L25.5463 37.2866ZM20.7066 33.1539L25.5463 28.3142L24.8392 27.6071L19.9995 32.4468L20.7066 33.1539Z",
    fill: "#101010",
    mask: "url(#path-4-inside-1_3177_3545)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 6.97827,
    r: 6,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2769 4.21598C24.2769 4.32836 24.3028 4.43487 24.3492 4.5302C24.3559 4.544 24.3457 4.56024 24.3299 4.56024H22.9202C22.6881 4.56024 22.5 4.74164 22.5 4.96542V6.333C22.5 6.34828 22.5169 6.35812 22.5312 6.35158C22.6296 6.30666 22.7395 6.28155 22.8555 6.28155C23.2761 6.28155 23.6171 6.61183 23.6171 7.01925C23.6171 7.42667 23.2761 7.75696 22.8555 7.75696C22.7395 7.75696 22.6296 7.73184 22.5312 7.68692C22.5169 7.68038 22.5 7.69023 22.5 7.70551V9.07309C22.5 9.29687 22.6881 9.47827 22.9202 9.47827H27.1568C27.3888 9.47827 27.5769 9.29687 27.5769 9.07309V4.96542C27.5769 4.74164 27.3888 4.56024 27.1568 4.56024H25.7469C25.7311 4.56024 25.7209 4.544 25.7276 4.5302C25.774 4.43487 25.7999 4.32836 25.7999 4.21598C25.7999 3.80855 25.459 3.47827 25.0384 3.47827C24.6178 3.47827 24.2769 3.80855 24.2769 4.21598ZM25.3179 6.20502C25.2276 6.11791 25.218 6.02335 25.218 5.75148C25.218 5.47962 24.9795 5.23757 24.685 5.23757C24.3906 5.23757 24.1521 5.46754 24.1521 5.75148C24.1521 6.03542 24.3906 6.2654 24.685 6.2654C25.064 6.2654 25.1309 6.32102 25.1684 6.35219L25.1684 6.35219C25.1702 6.35364 25.1718 6.35503 25.1735 6.35637C25.2308 6.40287 25.64 6.8063 25.64 6.8063C25.6746 6.84451 25.731 6.92173 25.75 7.03583V7.11382C25.75 7.32427 25.6053 7.45018 25.6053 7.45018L25.1611 7.8793C25.0708 7.96641 24.9727 7.97566 24.6908 7.97566C24.4089 7.97566 24.1579 8.20563 24.1579 8.48957C24.1579 8.77351 24.3964 9.00349 24.6908 9.00349C24.9852 9.00349 25.2237 8.77351 25.2237 8.48957C25.2237 8.12418 25.2814 8.05963 25.3137 8.02345L25.3137 8.02345C25.3152 8.02177 25.3167 8.02015 25.3181 8.01857C25.3663 7.96332 25.7846 7.56863 25.7846 7.56863C25.8283 7.5319 25.921 7.46971 26.0598 7.4582H26.2894C26.3875 7.4582 26.4671 7.38163 26.4671 7.28681V6.94429C26.4671 6.86554 26.4121 6.79909 26.3369 6.77907C26.3199 6.77385 26.3017 6.77103 26.2829 6.77103H26.0682C25.8762 6.7545 25.7629 6.63337 25.7629 6.63337L25.3179 6.20502Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpctls);
export default __webpack_public_path__ + "static/media/mpctls.6f965e13cb6e45e320e2278da3eb9992.svg";
export { ForwardRef as ReactComponent };